module.exports = __webpack_public_path__ + "static/media/MobileARCHIMATE.86fdcc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Archimate/MobileARCHIMATE.png
// module id = 112
// module chunks = 0